export interface Category {
  slug: string;
  name: string;
  tagline: string;
  desc: string;
  count: number;
}

export interface GossipItem {
  id: string;
  title: string;
  category: string;
  summary: string;
  heat: number; // 热度指数
  date: string;
  views: string;
  readMinutes: number;
  tags: string[];
  image: string;
  content: string[];
}

export const categories: Category[] = [
  {
    slug: "zongyi",
    name: "综艺名场面",
    tagline: "每一帧都有梗",
    desc: "热播综艺的爆点片段、高能现场与网友名梗，帮你第一时间接上综艺圈的讨论进度。",
    count: 3,
  },
  {
    slug: "yingshi",
    name: "影视热映",
    tagline: "追剧不迷路",
    desc: "新片热剧口碑观察、票房走势与观剧指南，聊聊那些值得熬夜追完的故事。",
    count: 3,
  },
  {
    slug: "yinyue",
    name: "乐坛现场",
    tagline: "耳朵先抵达",
    desc: "音乐节与舞台现场、新歌热榜与唱作观察，带你看舞台之下的真实热度。",
    count: 3,
  },
  {
    slug: "guancha",
    name: "圈内观察",
    tagline: "看得懂门道",
    desc: "从行业动向到观众情绪，用轻松视角拆解娱乐圈背后那些值得玩味的变化。",
    count: 3,
  },
];

export const articles: GossipItem[] = [
  {
    id: "juchang-zongyi-gaoshou",
    title: "综艺名场面复盘点：哪些瞬间刷屏到你没跟上",
    category: "zongyi",
    summary: "复盘近一个月综艺里最出圈的高能片段，从即兴接梗到临时加戏，看看网友为何疯狂截图二创。",
    heat: 986,
    date: "2026-09-08",
    views: "18.6万",
    readMinutes: 6,
    tags: ["综艺盘点", "名场面", "网友二创"],
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20bright%20variety%20show%20studio%20stage%20with%20colorful%20warm%20spotlights%20and%20confetti%20in%20the%20air%2C%20silhouetted%20hosts%20seen%20from%20behind%2C%20no%20visible%20faces%2C%20warm%20amber%20and%20red%20palette%2C%20editorial%20entertainment%20photography%2C%20high%20detail%20film%20grain%20composition&width=800&height=450&seq=hjg-zongyi-01&orientation=landscape",
    content: [
      "过去一个月，综艺舞台贡献了不止一次“出圈时刻”。相比精心设计的流程，真正被反复转发的往往是那些计划之外的自然反应——一次脱口而出的接梗、一个没绷住的表情、一段临时起意却意外高能的即兴表演。它们自带真实感，也最能戳中观众的情绪点。",
      "复盘这波热搜，名场面大多集中在竞技感与真实感并存的节目里。选手彼此较劲时迸发的火花、导师语出惊人的点评，往往比后期剪辑出来的悬念更让人上头。弹幕里那句“这段我可以看十遍”，几乎是它们统一的开场白。",
      "网友的二创能力同样功不可没。一个十秒的片段被配上文案、剪进混剪，再叠加上高赞评论区的层层解读，热度就这么滚雪球一样涨起来。名场面从来不只是节目自己的功劳，更是一场观众集体参与的游戏。",
      "如果你正好错过了某几期，别慌。这份按热度整理的合集把值得回看的高能片段都圈了出来，从爆笑瞬间到温情反转，按你自己的口味挑着补课就好。吃瓜不吃全，等于没吃瓜。",
    ],
  },
  {
    id: "qixiaying-dianshi-chaoxi",
    title: "暑期影视观察：喜剧回暖，观众为“解压”买单",
    category: "yingshi",
    summary: "从档期票房到口碑趋势，聊聊今年暑期观众为何越来越偏爱轻松解压的喜剧片与下饭剧。",
    heat: 921,
    date: "2026-09-07",
    views: "15.2万",
    readMinutes: 7,
    tags: ["影视观察", "暑期档", "喜剧回暖"],
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20cinema%20lobby%20scene%20with%20soft%20glowing%20amber%20lights%20and%20popcorn%20and%20film%20poster%20frames%20in%20soft%20bokeh%2C%20empty%20theater%20seats%20silhouette%20in%20warm%20red%20toned%20lighting%2C%20editorial%20photography%2C%20atmospheric%20film%20grain%2C%20no%20visible%20faces%2C%20high%20detail%20composition&width=800&height=450&seq=hjg-yingshi-01&orientation=landscape",
    content: [
      "暑期档的票房曲线往往比剧情还曲折。今年最直观的变化，是观众用脚投票的方向越来越明确：大家想看的，首先是可以让人暂时松口气的故事。喜剧类型集体回暖，市场用真金白银给出了答案。",
      "仔细拆解不难发现，走红的作品大多踩准了同一个情绪点——解压。它们未必有多深刻的立意，但节奏轻快、笑点密集、结局治愈，能让人在散场后带着好心情走出影院。在生活本就忙碌的时候，观众更愿意为“看得舒服”这件事买单。",
      "与此同时，小屏端的下饭剧也迎来一波热度高峰。三十分钟以内的体量、清爽不烧脑的剧情、配上高密度但温和的梗，让它们成为通勤与午休的黄金搭档。片方显然也在快速适应这种“轻量化”的观看习惯。",
      "当然，解压不等于敷衍。越是看起来轻松的作品，越需要扎实的表演与严谨的节奏兜底，否则很容易滑向尴尬。真正能留下来的“解压”，从来都是创作者在观众看不见的地方下了功夫的结果。",
    ],
  },
  {
    id: "yinyuewutai-shengyin",
    title: "舞台实力派回归：音乐节目为何又让人想看",
    category: "yinyue",
    summary: "回归现场的纯舞台竞技，让声音重新成为主角。聊聊今年音乐类节目再度受捧的三个理由。",
    heat: 889,
    date: "2026-09-06",
    views: "12.8万",
    readMinutes: 6,
    tags: ["音乐现场", "舞台竞技", "纯享舞台"],
    image: "https://readdy.ai/api/search-image?query=atmospheric%20concert%20stage%20with%20golden%20and%20crimson%20beams%20of%20light%20cutting%20through%20haze%2C%20microphone%20stand%20in%20focus%2C%20silhouetted%20crowd%20waving%20hands%20from%20behind%2C%20no%20visible%20faces%2C%20warm%20editorial%20music%20photography%2C%20cinematic%20film%20grain%2C%20dramatic%20high%20detail%20composition&width=800&height=450&seq=hjg-yinyue-01&orientation=landscape",
    content: [
      "当剪辑的“戏”看多了，观众反而开始想念纯粹的“舞台”。今年几档音乐节目不约而同地做减法：少一点剧本冲突，多一点白墙般的干净灯光，让声音本身站到舞台中央。事实证明，这种回归很奏效。",
      "舞台竞技之所以耐看，在于它有真实的悬念。同一首歌，不同的人唱是完全不同的故事。竞演模式把每一次开口都变成一次风险与惊喜并存的挑战，观众跟着屏息、跟着爆灯，情绪被稳稳拿捏。",
      "另一个原因是“还原”。越来越多节目开始尝试无修音或轻修音的呈现，把演唱现场最本真的呼吸与瑕疵一起保留。这种略带毛边的真实感，反而比完美无缺的成品更有打动人心的力量。",
      "对普通观众而言，看这类节目的乐趣不止于分高下，更像是在见证一段又一段声音被重新理解的过程。当一段旋律被唱到心里，输赢早就没那么重要了——重要的是那一晚你记住了那个声音。",
    ],
  },
  {
    id: "xuanyidrama-gongqing",
    title: "悬疑剧的进阶：从“烧脑”到“让人共情”",
    category: "yingshi",
    summary: "当逻辑不再只是炫技，当破案之外开始追问人心，悬疑题材正在完成一次温和的升级。",
    heat: 862,
    date: "2026-09-05",
    views: "11.4万",
    readMinutes: 8,
    tags: ["悬疑剧", "叙事进阶", "口碑剧"],
    image: "https://readdy.ai/api/search-image?query=moody%20film%20noir%20scene%20of%20a%20rain%20soaked%20narrow%20street%20alley%20at%20dusk%20with%20warm%20lamplight%20reflections%20on%20wet%20ground%2C%20lone%20figure%20walking%20away%20in%20shadow%2C%20no%20visible%20face%2C%20cinematic%20red%20and%20amber%20color%20grade%2C%20mysterious%20editorial%20photography%2C%20high%20detail%20film%20grain%20composition&width=800&height=450&seq=hjg-yingshi-02&orientation=landscape",
    content: [
      "悬疑题材最怕的就是“聪明到没人味”。过去那种把所有聪明全花在谜题设计上的路子，如今越来越难打动观众——大家不再只满足于被一道谜题难倒，而是想弄明白谜题背后站着怎样的人。",
      "今年的口碑悬疑剧几乎都印证了这个转向。它们依然把推理线编得严谨工整，但同时愿意慢下来，花大量篇幅去写人物：写动机的来龙去脉，写每个选择背后的无奈与执念。真相变得不那么“爽快”，却更加耐人寻味。",
      "这种升级其实是双向的。创作者在收窄猎奇的尺度，用更生活化的细节去包裹离奇的情节；观众也在变得更耐心，愿意为人物弧光留下足够的情绪。当“凶手是谁”不再提前泄底，剩下的观看乐趣反而更纯粹。",
      "或许未来的悬疑佳作，判断标准会悄悄改变——不只是“你猜对了吗”，而是“你心疼了吗”。能把人心写透的推理，才真正算得上高级。",
    ],
  },
  {
    id: "zongyi-huli-leixing",
    title: "类型综艺观察：垂直赛道如何留住观众",
    category: "zongyi",
    summary: "从露营到职场、从烘焙到推理，垂直类综艺遍地开花。它们靠什么把“小众”做成“圈层热”？",
    heat: 843,
    date: "2026-09-04",
    views: "9.8万",
    readMinutes: 7,
    tags: ["类型综艺", "垂直赛道", "圈层文化"],
    image: "https://readdy.ai/api/search-image?query=bright%20cheerful%20reality%20show%20kitchen%20workspace%20with%20fresh%20ingredients%20and%20cookware%20arranged%20on%20warm%20wooden%20table%2C%20sunlight%20through%20window%2C%20no%20people%2C%20warm%20amber%20and%20cream%20palette%2C%20cozy%20editorial%20lifestyle%20photography%2C%20high%20detail%20soft%20shadows%20composition&width=800&height=450&seq=hjg-zongyi-02&orientation=landscape",
    content: [
      "曾经“全民皆可”的综艺逻辑正在松动，取而代之的是一批把某一个生活切面做到极致的垂直节目。露营、烘焙、职场观察、剧本推理……每一种都自带精准的目标人群，也自带一套完整的话题语言。",
      "垂直综艺的聪明之处，在于它不贪多。它不指望所有人都看，而是希望喜欢这件事的人看到细节就“懂”。这种天然的门槛反而催生了强烈的归属感——观众不是在围观节目，更像是在参与一场同好之间的聚会。",
      "但要真正把“圈层热”维持下去并不容易。垂直题材最怕的不是小众，而是新鲜感耗尽后的同质化。当同类型的节目扎堆出现，拼的就是更专业的呈现与更独特的视角，谁先露出疲态，谁就先被观众划走。",
      "从趋势看，垂直综艺正在从“展示兴趣”转向“提供陪伴”。观众想要的，不只是看高手过招，更是有人替自己把喜欢的事情讲得热热闹闹、清清楚楚。谁先读懂这份需求，谁就能把一个小众赛道，做成一片长期生长的沃土。",
    ],
  },
  {
    id: "chengshibaotai-guancha",
    title: "从热搜到长尾：一场八卦能“活”多久",
    category: "guancha",
    summary: "同样是吃瓜，为什么有的热度三天就凉，有的却能在几天后翻出第二波高潮？聊聊舆论的周期律。",
    heat: 812,
    date: "2026-09-03",
    views: "10.1万",
    readMinutes: 7,
    tags: ["舆论观察", "吃瓜文化", "热搜"],
    image: "https://readdy.ai/api/search-image?query=overhead%20editorial%20still%20life%20of%20smartphone%20with%20glowing%20warm%20notification%20icons%20and%20paper%20clippings%20and%20magnifying%20glass%20on%20warm%20cream%20desk%2C%20coffee%20in%20amber%20ceramic%20cup%2C%20no%20people%2C%20warm%20red%20and%20gold%20tones%2C%20modern%20editorial%20photography%2C%20high%20detail%20soft%20light%20composition&width=800&height=450&seq=hjg-guancha-01&orientation=landscape",
    content: [
      "娱乐圈的注意力像极了潮汐：一波热搜涨起来，往往在几十小时内就见顶，随后迅速退潮。但细看会发现，真正有后劲的“瓜”，很少一锤定音。它会在几天后因某个新细节被重新捞起，滚出第二波、甚至第三波讨论。",
      "决定一场八卦能活多久的，首先是信息本身的层次。如果事件从头到尾只有一个事实，那它注定是一次性的。可一旦牵出动机、前史、相关人等层层线索，舆论就会自动进入“追更模式”，每隔一段时间翻出一点新东西，热度自然绵延。",
      "观众的“角色”也在其中发挥作用。有人负责考据细节、有人负责金句总结、还有人负责跨圈传播。一个话题能被聊得多深，往往取决于有没有这样一群愿意下功夫的参与者。吃瓜这件事，早就不是单方面的围观。",
      "当然，热度从来不该等同于价值。真正健康的内容生态，应当让那些经得起推敲的信息走得更远，而不是让每个标题都急着抢跑。热闹散去之后还能留下什么，才是衡量一次讨论是否有意义的标准。",
    ],
  },
  {
    id: "chumo-dianying-huiwei",
    title: "国产动画口碑回暖：国风美学的克制表达",
    category: "yingshi",
    summary: "不再是堆砌元素的“炫技”，而是把东方美学化进叙事里。聊聊国产动画近期的口碑突破。",
    heat: 795,
    date: "2026-09-02",
    views: "8.9万",
    readMinutes: 7,
    tags: ["国产动画", "国风美学", "口碑回暖"],
    image: "https://readdy.ai/api/search-image?query=elegant%20ink%20wash%20style%20animated%20landscape%20scene%20of%20traditional%20chinese%20mountains%20and%20flowing%20clouds%20at%20sunset%20with%20warm%20orange%20and%20red%20sky%2C%20a%20small%20pavilion%20and%20river%20below%2C%20painterly%20editorial%20visual%2C%20no%20characters%2C%20cinematic%20composition%2C%20high%20detail%20artistic%20rendering&width=800&height=450&seq=hjg-yingshi-03&orientation=landscape",
    content: [
      "如果把时间轴拉长，国产动画这几年的进步肉眼可见。最让人欣慰的变化，是它开始学会“收着做”。过去那种恨不得把传统元素全塞进画面的堆砌感正在消退，取而代之的是克制而精准的美学表达。",
      "如今口碑不错的作品，大多不再把国风当作一件外衣，而是把东方的审美逻辑揉进故事的骨血里。留白、含蓄、以景写情——这些手法和角色的处境、情节的推进悄悄咬合在一起，让画面不只是好看，更是会说话。",
      "技术层面同样在脱胎换骨。毛发、水流、衣袂的质感愈发成熟，但真正打动观众的，始终是技术终于学会了“为情绪服务”。当一段打斗不只是炫技而是带着人物的情绪张力，镜头的每一次定格都有了重量。",
      "当然，观众对国产动画的期待也被拔高了。它不再被当作“国产就宽容一些”的特殊作品，而是被放进与全球佳作同一把尺子下去比较。这既是压力，也是它真正走向成熟的证明。",
    ],
  },
  {
    id: "weilaizongyi-ai-pingjia",
    title: "不止是好笑：慢综艺的“治愈经济学”",
    category: "zongyi",
    summary: "种地、赶海、开民宿……慢综艺为什么总能让都市人破防？背后其实是精准的情绪生意。",
    heat: 768,
    date: "2026-09-01",
    views: "7.6万",
    readMinutes: 6,
    tags: ["慢综艺", "治愈系", "情绪消费"],
    image: "https://readdy.ai/api/search-image?query=peaceful%20rural%20sunset%20scene%20of%20green%20rice%20field%20with%20warm%20golden%20light%20and%20a%20small%20wooden%20farmhouse%20in%20the%20distance%2C%20dragonflies%20over%20the%20water%2C%20no%20people%2C%20warm%20amber%20and%20green%20pastoral%20palette%2C%20calming%20editorial%20photography%2C%20high%20detail%20soft%20natural%20light%20composition&width=800&height=450&seq=hjg-zongyi-03&orientation=landscape",
    content: [
      "在高强度工作成为日常的今天，一群明星挽起裤脚下地插秧、围在灶台边生火做饭的画面，意外地成为都市人的“精神粮仓”。慢综艺的走红，本质是一场精准的情绪生意。",
      "它贩卖的不是情节，而是节奏。快综艺用剪辑制造紧张感，慢综艺却反其道而行之，把镜头对准那些被我们习以为常地忽略的生活细节：一锅汤慢慢炖熟、一片地翻完晾晒、日头从早到晚地移动。看得越久，越能感到一种久违的松弛。",
      "这种治愈感其实有迹可循。当现实生活被效率与KPI不断压缩，慢综艺提供了一个相对安静的精神出口，让人隔着屏幕短暂地“慢下来”。它不见得真有改变生活的魔力，但那种被温柔对待的错觉，本身就很值钱。",
      "也正因如此，慢综艺最忌用力过猛。一旦开始硬凹感动、强行上价值，那份难得的松弛就会瞬间破功。治愈的核心始终是“不打扰”——让镜头安静地陪着生活走一段，观众自然会给出他们最诚实的反馈。",
    ],
  },
  {
    id: "taoliuyinyue-fushi",
    title: "复古浪潮再起：为什么我们反复爱上旧旋律",
    category: "yinyue",
    summary: "从经典老歌翻唱到复古disco复兴，市场不断证明：真正的审美偏好，常常是螺旋上升的。",
    heat: 744,
    date: "2026-08-31",
    views: "6.8万",
    readMinutes: 6,
    tags: ["复古潮流", "经典翻唱", "音乐市场"],
    image: "https://readdy.ai/api/search-image?query=retro%20vinyl%20record%20spinning%20on%20a%20turntable%20in%20warm%20golden%20lamp%20light%20with%20scattered%20cassette%20tapes%20and%20old%20magazines%2C%20no%20people%2C%20warm%20amber%20and%20crimson%20nostalgic%20palette%2C%20cozy%20editorial%20photography%2C%20high%20detail%20film%20grain%20still%20life%20composition&width=800&height=450&seq=hjg-yinyue-02&orientation=landscape",
    content: [
      "每隔几年，音乐市场就会刮起一阵复古风。经典老歌被重新编曲、短视频让旧旋律再次霸榜、复古disco与city-pop成为新一代的“新欢”。看似是轮回，实则藏着耐人寻味的审美逻辑。",
      "人们怀念老歌，往往不只是怀念旋律本身，更是怀念旋律绑定的那段记忆。熟悉的副歌一响，瞬间把人拉回某个夏天、某趟通勤、某段关系。音乐是最廉价也最精准的时光机，这一点从未改变。",
      "而复古的复兴也离不开“再加工”。纯粹的老旧很难吸睛，真正翻红的，是被当代审美重新调校过的版本：保留抓耳的旋律骨架，换上更现代的音色与编曲，让旧记忆与新听感在同一首歌里相遇。",
      "说到底，审美偏好很少走直线，更多是螺旋上升。市场兜兜转转，最终还是会回到那些经过时间检验、仍然能打动人的东西。所谓流行，不过是每个时代都有新办法，让旧情绪重新被听见。",
    ],
  },
  {
    id: "zhuanyilangchao-yingxiang",
    title: "翻拍与续作扎堆：情怀生意还能走多远",
    category: "guancha",
    summary: "经典翻拍、热门续作、IP重启接连定档，情怀牌屡试不爽的背后，也藏着市场对“新东西”的渴望。",
    heat: 720,
    date: "2026-08-30",
    views: "6.1万",
    readMinutes: 7,
    tags: ["翻拍续作", "IP经济", "市场观察"],
    image: "https://readdy.ai/api/search-image?query=cinematic%20movie%20clapperboard%20and%20script%20pages%20on%20a%20warm%20wooden%20director%20desk%20with%20vintage%20film%20reel%20and%20glowing%20amber%20desk%20lamp%2C%20no%20people%2C%20warm%20editorial%20behind%20the%20scenes%20photography%2C%20high%20detail%20dramatic%20soft%20light%20composition&width=800&height=450&seq=hjg-guancha-02&orientation=landscape",
    content: [
      "打开片单，翻拍、续作与IP重启几乎填满了大半排期。情怀牌确实屡试不爽——熟悉的角色一亮相、经典台词一响起，观众的记忆闸门就被打开，票房与热度自然有了保底。但这门生意，正变得越来越难做。",
      "情怀的甜蜜期很短暂。第一批观众为回忆买单，可一旦新鲜感耗尽，剩下的就全靠作品本身撑场。如果续作只是在消费旧名头、内容却撑不起预期，口碑反噬的速度会比想象中更快，甚至透支掉原作的号召力。",
      "更值得留意的是，年轻观众正在用行动表达一种“既要又要”的需求：他们要情怀，更要诚意。翻拍不是把旧故事换个主角重演一遍，而是要讲出旧IP在新语境下的新价值。用旧的壳，装得下新的魂，才算真正的成功。",
      "市场的耐心其实没有想象中那么多。情怀是敲门砖，不是免死金牌。真正能让一个经典IP走得很远的，永远是创作本身——当观众开始讨论故事而不只是回忆时，这门情怀生意才算真正找到了可持续的活法。",
    ],
  },
  {
    id: "yinyuejie-xianchang-chengyin",
    title: "音乐节下沉：现场经济的新玩法与新烦恼",
    category: "yinyue",
    summary: "演出市场火爆，音乐节从一线蔓延到小城。热闹背后，考验的是主办方的组织能力与城市承接力。",
    heat: 698,
    date: "2026-08-29",
    views: "5.5万",
    readMinutes: 6,
    tags: ["音乐节", "现场经济", "演出市场"],
    image: "https://readdy.ai/api/search-image?query=vibrant%20outdoor%20music%20festival%20scene%20at%20dusk%20with%20large%20stage%20lights%20in%20warm%20amber%20and%20crimson%2C%20festival%20flags%20and%20tent%20silhouettes%2C%20crowd%20from%20behind%20jumping%20and%20raising%20hands%2C%20no%20visible%20faces%2C%20energetic%20editorial%20photography%2C%20high%20detail%20warm%20color%20composition&width=800&height=450&seq=hjg-yinyue-03&orientation=landscape",
    content: [
      "当“去现场听歌”重新成为一种生活方式，音乐节也从一线城市的固定节目，逐渐向更下沉的城市蔓延。小城办节，既能拉动本地消费，也让更多乐迷免去长途奔波，看起来是双赢的局。",
      "但热闹不等于成熟。音乐节走进新城市，考验的是从票务、交通到住宿、卫生的一整套承接能力。阵容豪华只是第一步，能不能让几千名乐迷顺畅进场、安心熬夜、舒服返程，才是真正决定口碑的细节。",
      "对主办方而言，下沉意味着更低的容错率。小城观众未必熟悉行业惯例，一旦服务跟不上，负面印象会被迅速放大，甚至影响一个地方未来对办节的态度。谨慎扩张，往往比盲目铺开更重要。",
      "当然，现场经济的想象力依然可观。一场成功的音乐节，能带动餐饮、文旅、住宿的一整条链条。对城市与主办方来说，真正的问题不是要不要办，而是能不能把“办一场”的流量，沉淀成“年年办”的信任。",
    ],
  },
  {
    id: "quanwang-zouhong-guanxi",
    title: "选秀退场后，新人凭什么“一夜走红”",
    category: "guancha",
    summary: "曾经的造星流水线按下了暂停键，新人出圈的路却并没有变窄。盘点当下让人记住名字的几种方式。",
    heat: 676,
    date: "2026-08-28",
    views: "5.2万",
    readMinutes: 7,
    tags: ["新人出圈", "内容造星", "行业观察"],
    image: "https://readdy.ai/api/search-image?query=dramatic%20spotlight%20on%20an%20empty%20stage%20floor%20with%20a%20single%20microphone%20and%20lens%20flare%20in%20warm%20golden%20light%20against%20dark%20theater%20background%2C%20no%20person%2C%20warm%20red%20and%20amber%20cinematic%20photography%2C%20high%20detail%20moody%20composition&width=800&height=450&seq=hjg-guancha-03&orientation=landscape",
    content: [
      "曾经，一条高曝光度的选秀综艺几乎等于造星流水线。如今这条流水线按下了暂停键，但翻看社交媒体，依然不断有新人以意想不到的方式进入大众视野。出圈的路，其实并没有变窄。",
      "当下最容易让人记住名字的路径，往往与“内容”强相关。一段被反复转发的舞台片段、一个足够有辨识度的创作、甚至一次真诚到让人破防的直播，都可能成为启动认知的开关。作品自己会说话，成了新人最可靠的朋友。",
      "与过去不同的是，如今的新人更像是在经营一场“长期关系”而非“速食爆红”。粉丝不再只对着镜头里的完美形象欢呼，而是更愿意追随一个真实、有成长轨迹、愿意持续输出的个体。一夜爆红之后能不能留下来，拼的还是持续的内容能力。",
      "这也让“红”的定义发生了变化。它不再只是被几亿人认识，而是被一小群愿意支持你的人稳稳记住。对真正有才华的新人来说，这或许反而是件好事——不必急着制造记忆点，沉下心把作品做扎实，路自然会越走越宽。",
    ],
  },
  {
    id: "nongcun-dianshi-zhenren",
    title: "生活类真人秀翻红：把“普通日子”拍出追更感",
    category: "zongyi",
    summary: "告别竞技与冲突，越来越多的节目把镜头对准真实生活。平淡日子为何反而让人看得停不下来？",
    heat: 655,
    date: "2026-08-27",
    views: "4.9万",
    readMinutes: 6,
    tags: ["生活类综艺", "真实感", "口碑节目"],
    image: "https://readdy.ai/api/search-image?query=warm%20homely%20scene%20of%20a%20bright%20lived%20in%20apartment%20kitchen%20with%20sunlight%20on%20the%20counter%20and%20fresh%20breakfast%20and%20green%20plants%2C%20no%20people%2C%20warm%20cream%20and%20amber%20editorial%20photography%2C%20cozy%20documentary%20feel%2C%20high%20detail%20natural%20light%20composition&width=800&height=450&seq=hjg-zongyi-04&orientation=landscape",
    content: [
      "竞技带来的紧张感曾经是综艺的流量密码，但最近风向明显在变。一批不再“搞事情”的生活类真人秀悄悄翻红——镜头里没有淘汰、没有剧本冲突，只有真实的日子一天天流淌。观众却追得比谁都起劲。",
      "这类节目赢在一种难得的“在场感”。它不试图证明什么，只是诚实地记录房间如何被打扫、晚饭如何被端上桌、一个人如何笨拙地学习照顾自己。越是平平无奇，越容易让屏幕前的人找到自己的影子。",
      "生活流叙事的魅力，也在于它的不可预知。真实生活里没有写好的剧本，一个小小的决定就可能引发一整天的连锁反应。这种恰到好处的“失控”，比精心设计的反转更让人牵挂，催生出一种追着看“接下来会发生什么”的冲动。",
      "当然，真实感也是一把双刃剑。一旦被观众察觉人设与滤镜，好感会迅速崩塌。把普通日子拍出追更感的前提，是主创真的愿意放下身段、把镜头后的生活交给镜头。诚不诚心，观众一眼便知。",
    ],
  },
];

export interface HotRank {
  no: number;
  title: string;
  tag: "爆" | "热" | "新";
  category: string;
  articleId: string;
}

export const hotRanks: HotRank[] = [
  { no: 1, title: "综艺名场面复盘点：哪些瞬间刷屏到你没跟上", tag: "爆", category: "综艺", articleId: "juchang-zongyi-gaoshou" },
  { no: 2, title: "暑期影视观察：喜剧回暖，观众为“解压”买单", tag: "热", category: "影视", articleId: "qixiaying-dianshi-chaoxi" },
  { no: 3, title: "舞台实力派回归：音乐节目为何又让人想看", tag: "热", category: "乐坛", articleId: "yinyuewutai-shengyin" },
  { no: 4, title: "悬疑剧的进阶：从“烧脑”到“让人共情”", tag: "新", category: "影视", articleId: "xuanyidrama-gongqing" },
  { no: 5, title: "类型综艺观察：垂直赛道如何留住观众", tag: "热", category: "综艺", articleId: "zongyi-huli-leixing" },
  { no: 6, title: "从热搜到长尾：一场八卦能“活”多久", tag: "新", category: "观察", articleId: "chengshibaotai-guancha" },
  { no: 7, title: "不止是好笑：慢综艺的“治愈经济学”", tag: "热", category: "综艺", articleId: "weilaizongyi-ai-pingjia" },
  { no: 8, title: "复古浪潮再起：为什么我们反复爱上旧旋律", tag: "新", category: "乐坛", articleId: "taoliuyinyue-fushi" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "海角吃瓜多久更新一次热门内容？",
    a: "我们每天分早中晚多次整理最新娱乐爆料与热搜动态，围绕综艺、影视、乐坛和圈内观察四大板块持续更新，按热度实时聚合最新瓜料与高赞讨论，方便你快速跟上讨论进度。",
  },
  {
    q: "吃瓜合集和大盘点什么区别？",
    a: "吃瓜合集通常聚焦某一个具体话题或人物，把一个事件的前因后果、时间线与各方反应整理成完整脉络；大盘点则是按主题（如某段时间的综艺名场面、某类题材的口碑剧）横向汇总多起热点，方便一次性浏览全景。",
  },
  {
    q: "视频专区的内容可以跳转观看吗？",
    a: "可以。视频专区收录的是与当前热榜对应的完整节目片段与官方物料链接，点击封面即可跳转到对应平台观看原片，确保你所看的内容来源清晰、可追溯。",
  },
  {
    q: "如何快速找到最近错过的热门瓜？",
    a: "建议优先使用首页的实时热榜与“热门合集”栏目，榜单按热度实时排序，大盘点则会滚动收录近期的高能名场面与高赞话题。你也可以通过页面顶部的搜索框按关键词查找，或按分类进入对应频道追更。",
  },
  {
    q: "对整理内容有补充或想参与共建，该怎么办？",
    a: "欢迎通过页面底部的联系邮箱与我们交流。我们在整理信息时以公开、可核实的公开信息为准，任何投稿与纠错建议我们都会认真对待，并坚持去伪存真、理性吃瓜的内容原则。",
  },
];